// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from '../ServiceRequest';
import type RequestOptions from '../RequestOptions';
import type GetMailboxCalendarConfigurationResponse from '../contract/GetMailboxCalendarConfigurationResponse';

export default function getMailboxCalendarConfigurationOperation(
    options?: RequestOptions
): Promise<GetMailboxCalendarConfigurationResponse> {
    return makeServiceRequest<GetMailboxCalendarConfigurationResponse>(
        'GetMailboxCalendarConfiguration',
        {},
        options
    );
}
